import type { IntlShape } from 'react-intl'

import type { TripListRowType } from './tripListTypes'

export function getTripListTypeLabel(intl: IntlShape, rowType: TripListRowType): string {
  switch (rowType) {
    case 'accommodation':
      return intl.formatMessage({
        id: 'LXkooFDsWt3QWfgxHWBu',
        defaultMessage: 'Accommodation',
        description: 'Type label for accommodation rows in the trip planner list view',
      })
    case 'experience':
      return intl.formatMessage({
        id: 'Lw81QDqeWEEKI7pwr7Gf',
        defaultMessage: 'Experience',
        description: 'Type label for experience rows in the trip planner list view',
      })
    case 'dining':
      return intl.formatMessage({
        id: '9RDR4uVoGZGTrt4aUaR0',
        defaultMessage: 'Dining',
        description: 'Type label for dining rows in the trip planner list view',
      })
    case 'flight':
      return intl.formatMessage({
        id: '3sNviGCg_3hPjIrORrqy',
        defaultMessage: 'Flight',
        description: 'Type label for flight rows in the trip planner list view',
      })
    case 'transport':
      return intl.formatMessage({
        id: 'uA-QbVi1OBq5fv6lCsvE',
        defaultMessage: 'Transport',
        description: 'Type label for transport rows in the trip planner list view',
      })
    case 'cruise':
      return intl.formatMessage({
        id: 'sEBaZVnusNRhNsP_ORD4',
        defaultMessage: 'Cruise',
        description: 'Type label for cruise rows in the trip planner list view',
      })
    case 'activity':
      return intl.formatMessage({
        id: 'ho7Et-s3cZu3GJeaAr9Y',
        defaultMessage: 'Activity',
        description: 'Type label for activity rows in the trip planner list view',
      })
    default:
      return rowType
  }
}
